/**
 * Slide animation variants for Framer Motion
 */

import { Variants } from 'framer-motion';

// Slide animations
export const slideInFromLeft: Variants = {
  initial: { opacity: 0, x: -100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 }
};

export const slideInFromRight: Variants = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 100 }
};

export const slideInFromTop: Variants = {
  initial: { opacity: 0, y: -100 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -100 }
};

export const slideInFromBottom: Variants = {
  initial: { opacity: 0, y: 100 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 100 }
};

export const slideOutToLeft: Variants = {
  initial: { opacity: 1, x: 0 },
  animate: { opacity: 0, x: -100 },
  exit: { opacity: 1, x: 0 }
};

export const slideOutToRight: Variants = {
  initial: { opacity: 1, x: 0 },
  animate: { opacity: 0, x: 100 },
  exit: { opacity: 1, x: 0 }
};
